// Перегруппировка (deus_peregruppirovka, action) — цель: любой юнит (свой или чужой).
// В Ф3: убирается с поля, возвращается в руку владельца. Если рука переполнена (10) — карта сгорает.
// Влияние-триггеры (Сина-deathSelf) НЕ срабатывают — это не смерть.
// Все Модификации с карты снимаются (для Деуса не критично — но логика общая).

import { onUnitLeftField } from './hooks.js';
import { Card } from '../../card.js';

export const CARD_ID = 'deus_peregruppirovka';

export function getPeregruppirovkaTargets(state /*, playerIdx */) {
  const out = [];
  for (const p of state.players) {
    for (const u of p.unitsOnField()) out.push(u);
  }
  return out;
}

export function resolvePeregruppirovka(state, playerIdx, targetCard) {
  const player = state.players[playerIdx];
  if (!targetCard || !targetCard.isAlive()) {
    state.log.add(`🔄 ${player.name}: Перегруппировка — цель недоступна`);
    return { ok: false, reason: 'invalid_target' };
  }
  const ownerIdx = targetCard.ownerId;
  const owner = state.players[ownerIdx];
  // Снять с поля (без триггеров смерти).
  if (targetCard.line !== null && targetCard.slot !== null) {
    owner.field[targetCard.line][targetCard.slot] = null;
  }
  targetCard.line = null;
  targetCard.slot = null;
  // Сбросить модификации.
  resetCardMods(targetCard);
  // Вернуть в руку или сжечь.
  if (owner.hand.length >= 10) {
    owner.discard.push(targetCard);
    targetCard.alive = false;
    state.log.add(`🔄 ${player.name}: Перегруппировка — рука [${owner.name}] полна, "${targetCard.name_ru}" сгорает`);
  } else {
    owner.hand.push(targetCard);
    state.log.add(`🔄 ${player.name}: Перегруппировка — ${targetCard.name_ru} возвращается в руку [${owner.name}]`);
  }
  onUnitLeftField(state, ownerIdx, targetCard);
  return { ok: true };
}

// Сбросить модификации карты при возврате в руку.
function resetCardMods(card) {
  card.current.atk = card.base.atk;
  card.current.armor = card.base.armor;
  card.current.hp = card.base.hp;
  card.persistentArmor = 0;
  card.persistentMaxArmor = 0;
  card.tempArmorBands = [];
  card.directorAuraApplied = { atk: 0, armor: 0, hp: 0 };
  card.placedTurn = null;
  card.revealed = false;
  card.activated = false;
  card.heroAttackedThisTurn = false;
  // А.4.4.4-fix1: при возврате в руку Спящий перестаёт быть «спящим».
  card.sleeperState = null;
  card.side = 'owner';
  // А.4.5-fix4-retry2: бонус Ликвидатора-эксперта сбрасывается (новая «жизнь» на поле).
  card.likvidatorEkspertBonus = 0;
  // Восстанавливаем оригинальные keywords.
  if (card.template?.keywords) {
    card.keywords = [...card.template.keywords];
  }
}
